import { FCEVENT } from "./fc";
import { GrandComponent, GetMainObjWay } from "./grand.component";
import { Sysappfields, Sysappbuttons } from "fccore2";
import { CacheService } from "fccore2";
import { ObjStatus } from "fccore2";
import { ParentBusiness } from 'fccore2';
export abstract class ParentDetailComponent extends GrandComponent {
    /**é»è®¤éä¸­çç´¢å¼*/
    selectedIndex: number;
    /**æ¯å¦æä¸ä¸æ¡*/
    hasNext: boolean;
    /**æ¯å¦æä¸ä¸æ¡*/
    hasPrev: boolean;
    /**ç¼å­å¯¹è±¡åå®¹ï¼ä¸»è¦æ¯å¨ä¸ä¸æ¡ä¸ä¸æ¡ä½¿ç¨*/
    mainObjs: any[];
    /**å½åä¸»å¯¹è±¡*/
    mainObj: any;
    /**è¡¨åå­æ®µåè¡¨*/
    mainFields: Sysappfields[];
    /**è¡¨åå·¥å·æ æé®*/
    mainButtons: Sysappbuttons[];
    /**å½åå¯¹è±¡ç¶æ*/
    objStatus = ObjStatus.READ;
    /**
     * æ ¹æ®äº§åidååè½idåå§åç¸å³çåå®¹
     * @param pid äº§åid
     * @param aid æ¨¡åid
     */
    constructor(pid?: string, aid?: string) {
        super(pid, aid);
    }
    /**
     * å­ç±»åå§å
     */
    abstract init(): void;
    /**
     * åå§åå½åå¯¹è±¡åå®¹,åå«åå§åæ ¡éªä¸ä¸æ¡ä¸ä¸æ¡ï¼å½åæç»å¯¹è±¡
     */
    _init() {
        /**é»è®¤ä»ç¼å­ä¸­è·åæ°æ®*/
        this.getMainObjWay = GetMainObjWay.cache;
        /**é»è®¤éä¸­çç´¢å¼*/
        this.selectedIndex = 0;
        /**æ¯å¦æä¸ä¸æ¡*/
        this.hasNext = false;
        /**æ¯å¦æä¸ä¸æ¡*/
        this.hasPrev = false;
        /**å½åä¸»å¯¹è±¡*/
        this.mainObj = {};
        /** å½åå*/
        this.mainFields = this.mainApp ? ParentBusiness.appService.getFormFieldsByApp(this.mainApp) : [];
        /** å½æidåæ°ä¼ æ¡ä»¶è¿æ¥çæ¶åå¤çè¿ç¨*/
        if (this.routerParam.ID) {
            /** è·ååè¡¨ä¼ éè¿æ¥çå¯¹è±¡*/
            this.mainObjs = CacheService.getS(this.appId + "DATA");
            /** é»è®¤ä¸ºåªè¯»ç¶æï¼æ è®°å½åå¯¹è±¡æªè¢«ä¿®æ¹*/
            this.objStatus = ObjStatus.READ;
            /** é»è®¤è·åå¯¹è±¡çåå®¹çç­ç¥ä¸ºç¼å­è·åçæ¶åï¼ä»ç¼å­*/
            if (this.getMainObjWay === GetMainObjWay.cache) {
                /** åè¡¨å¯¹è±¡åå®¹å­å¨çæ¶å*/
                if (this.mainObjs) {
                    /** è·åéä¸­çæ°æ®å¯¹è±¡*/
                    let selObjs = this.mainObjs.filter(obj => {
                        /** æ¯å¦å­å¨ä¸ä¸æ¡ä¸ä¸æ¡*/
                        this.checkHasOne();
                        /** å½åéæ©çç´¢å¼++ï¼å½éä¸­çæ¶åï¼é»è®¤çç´¢å¼å°±æ¯åè¡¨æå¨çä½ç½®*/
                        this.selectedIndex++;
                        /** å½åidç¸ç­æ¯æ è¯å­å¨æ­¤è®°å½ã*/
                        return this.routerParam.ID === obj.ID
                    });
                    /** æ ¡éªæ¯å¦æ¾å°æ­¤è®°å½ï¼å­å¨åèµå¼*/
                    if (selObjs && selObjs.length !== 0) {
                        this.mainObj = selObjs[0];
                    }
                }
                /** å½å¯¹è±¡æ²¡ææ¾å°çæ¶åä»æå¡å¨è·åå¯¹è±¡åå®¹ã*/
                if (this.mainObj === null) {
                    /** æ ¹æ®å½åæ¨¡åidï¼æ°æ®idè·åå½åå¯¹è±¡åå®¹ã*/
                    this.pushDestroy(ParentBusiness.appService.findById(this.mainApp.APPID, this.routerParam.ID).subscribe(result => {
                        if (result.CODE === '0') {
                            /** åå§åä¸»å¯¹è±¡*/
                            this.mainObj = result.DATA;
                            /** æ¯å¦å­å¨ä¸ä¸æ¡ä¸ä¸æ¡*/
                            this.checkHasOne();
                        }
                        /** åå§åå­ç±»*/
                        this.init();
                    }));
                } else {
                    /** åå§åå­ç±»*/
                    this.init();
                }
            } else {
                /** å½è·åå¯¹è±¡çåå®¹ç­ç¥ä¸ºåç«¯è·åçæ¶åï¼åä»åç«¯è·å*/
                this.pushDestroy(ParentBusiness.appService.findById(this.appId, this.routerParam.ID).subscribe(result => {
                    if (result.CODE === '0') {
                        this.mainObj = result.DATA;
                        /** æ ¡éªæ¯å¦å­å¨ä¸ä¸æ¡ä¸ä¸æ¡*/
                        this.checkHasOne();
                    }
                    /** åå§åå­ç±»*/
                    this.init();
                }));
            }
        } else {
            /** å½ä¸å­å¨æ¶åï¼é»è®¤å¼ä¿®æ¹ä¸ºè¯»ç¶æ*/
            this.objStatus = ObjStatus.READ;
            /** æ²¡æä¸ä¸æ¡*/
            this.hasNext = false;
            /** æ²¡æä¸ä¸æ¡*/
            this.hasPrev = false;
            /** åå§åä¸ä¸ªé»è®¤çå¯¹è±¡ï¼*/
            this.mainObj = ParentBusiness.appService.initObjDefaultValue(this.mainApp);
            this.init();
        }
    }
    /**
     * æ ¡éªæ¯å¦å­å¨ä¸ä¸æ¡ä¸ä¸æ¡
     */
    checkHasOne(): void {
        if (this.mainObjs[this.selectedIndex + 1]) {
            this.hasNext = true;
        }
        if (this.mainObjs[this.selectedIndex - 1]) {
            this.hasPrev = true;
        }
    }
    /**
     * ä¸ä¸æ¡
     *  
     */
    prev(): void {
        if (this.selectedIndex !== -1) {
            if (this.mainObjs && this.mainObjs.length > 0) {
                this.selectedIndex--;
                this.checkHasOne();
                this.mainObj = this.mainObjs[this.selectedIndex];
            }
        }
    }
    /**
     * ä¸ä¸æ¡
     *  
     */
    next(): void {
        if (this.selectedIndex !== -1) {
            if (this.mainObjs && this.mainObjs.length > 0) {
                this.selectedIndex++;
                this.mainObj = this.mainObjs[this.selectedIndex];
                this.checkHasOne();
            }
        }
    }

    /**
     * è¡¨åè¿å
     * @param action äºä»¶åç§°
     */
    cardBack(action: string): void {
        this.navigateList();
    }

    /**   
     * è¡¨åå·¥å·æ äºä»¶
     * @param event äºä»¶
     */
    tlbformEvent(event: FCEVENT) {
        this.adformEvent(event);
    }
    /**
     * æ ¹æ®åè¡¨å¤çäºä»¶
     * @param action äºä»¶åç§°
     */
    adformEvent(event: FCEVENT) {
        switch (event.eventName) {
            case 'cardBack':
                this.cardBack(event.eventName);
                break;
            case 'cardAdd':
                this.navigateAdd();
            case 'cardEdit':
                this.navigateEdit();
                break;
            default:
                this.event(event.eventName, event);
        }
    }

    /**
     * è·³è½¬è³æ°å¢é¡µé¢
     */
    navigateAdd() {
        this.navigate(this.getRouteUrl('Edit'), { refresh: 'Y' });
    }
    /**
     * è·³è½¬è³ç¼è¾é¡µé¢
     */
    navigateEdit() {
        CacheService.setS(this.mainObj.ID, this.mainObj);
        this.navigate(this.getRouteUrl('Edit'), { ID: this.mainObj.ID, refresh: 'Y' });
    }

    /**
     * è·³è½¬è³åè¡¨é¡µé¢
     * @param reflesh 
     */
    navigateList(refresh?: boolean) {
        this.navigate(this.getRouteUrl('List'), { refresh: refresh ? refresh : 'Y' });
    }
}

